<ion-content color="primary">

  <div class="center-page-wrapper">
    <div class="center-vert">
      <div class="large-text">We can’t retrieve you</div>
      <div class="message">
        To find nearest locations, location services must be enabled or let us know your city/state or zip/postal code
      </div>

      <form novalidate [formGroup]="form" *ngIf="form">
        <ion-input formControlName="zipcode" placeholder="City/State or Zip/Postal Code" clearInput="true" (ionChange)="validating = true"></ion-input>
      </form>

      <div class="info">{{ address }}</div>

      <div class="ion-text-center confirm-button">
        <ion-button shape="round" expand="full" color="secondary" [disabled]="!form?.valid" fill="solid"
          (click)="save()">
          {{validating ? 'Validate' : 'Confirm'}}
        </ion-button>
      </div>

    </div>
  </div>
</ion-content>